var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 7.813a29.687 29.687 0 000 59.374 2.344 2.344 0 110 4.688c-18.984 0-34.375-15.39-34.375-34.375C3.625 18.516 19.015 3.125 38 3.125c18.984 0 34.375 15.39 34.375 34.375a2.344 2.344 0 11-4.688 0A29.687 29.687 0 0038 7.812z",
    fill: "#FEDF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.497 54.625l11.65 10.356a.963.963 0 001.603-.718V56.25h13.281a2.343 2.343 0 100-4.688H56.75V43.55a.962.962 0 00-1.603-.719l-11.65 10.356a.96.96 0 000 1.438zM54.5 29a2.342 2.342 0 00-3.313-3.313L32.532 44.341l-7.718-7.716a2.342 2.342 0 00-3.313 3.313l9.375 9.374a2.342 2.342 0 003.313 0L54.5 29z",
    fill: "#FEDF00"
  })));
}

export default SvgSuccess;